import { render, staticRenderFns } from "./nbn-bulk-upload.vue?vue&type=template&id=a2970af8&scoped=true"
import script from "./nbn-bulk-upload.vue?vue&type=script&lang=js"
export * from "./nbn-bulk-upload.vue?vue&type=script&lang=js"
import style0 from "./nbn-bulk-upload.vue?vue&type=style&index=0&id=a2970af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2970af8",
  null
  
)

export default component.exports